import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Component({
    selector: 'app-timer',
    template: `<p>{{ minutes }}:{{ seconds | number: '2.0' }}</p>`,
    standalone: false
})
export class TimerComponent implements OnInit {
  private destroy = inject(DestroyRef);
  protected minutes: number = 5;
  protected seconds: number = 0;

  ngOnInit() {
    this.startTimer();
  }

  private startTimer() {
    interval(1000)
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe(() => {
        if (this.seconds === 0) {
          if (this.minutes > 0) {
            this.minutes--;
            this.seconds = 59;
          }
        } else {
          this.seconds--;
        }
      });
  }
}
